'use client';

import * as React from 'react';
import { useAppSelector } from '@/store/hooks';
import { getDrawerContent } from '@/store/reducers/drawer-content-slice';
import { useColorScheme } from '@mui/material';

import JsonView from '@/components/core/json-view';

export function BetJsonTab(): React.JSX.Element | null {
  const { colorScheme } = useColorScheme();

  const { BET_DETAILS: data } = useAppSelector(getDrawerContent);

  return data ? <JsonView src={data} theme={colorScheme === 'dark' ? 'monokai' : 'bright:inverted'} /> : null;
}
